import { matchPath } from 'react-router-dom';
import {
    ISideNavChildEntry,
    ISideNavItem,
    ISideNavSubGroupHeader,
    ISideNavSubItem,
} from './interfaces';

export const isSideNavSubGroupHeader = (
    entry: ISideNavChildEntry,
): entry is ISideNavSubGroupHeader => 'kind' in entry && entry.kind === 'subgroupHeader';

export const isSideNavSubLink = (entry: ISideNavChildEntry): entry is ISideNavSubItem => (
    !isSideNavSubGroupHeader(entry)
);

export const hasSubgroupHeaders = (children: ISideNavChildEntry[]): boolean => (
    children.some(isSideNavSubGroupHeader)
);

const normalizePathPattern = (to: string): string => {
    if (/^https?:\/\//.test(to)) {
        try {
            return new URL(to).pathname;
        } catch {
            return to;
        }
    }
    return to;
};

export const isPathActive = (pathname: string, to: string | undefined): boolean => {
    if (!to) {
        return false;
    }
    const pathPattern = normalizePathPattern(to);
    const end = !pathPattern.includes(':');
    return matchPath({ path: pathPattern, end }, pathname) !== null;
};

export const isItemActive = (item: ISideNavItem, pathname: string): boolean => {
    if (item.kind !== 'standard') {
        return false;
    }
    if (item.isActive) {
        return item.isActive(pathname);
    }
    return isPathActive(pathname, item.to);
};

export const hasActiveChild = (item: ISideNavItem, pathname: string): boolean => (
    item.kind === 'hasChildren'
    && (item.children ?? [])
        .filter(isSideNavSubLink)
        .some(child => isPathActive(pathname, child.to))
);

export const isTopNavSection = (sectionId: string): boolean => (
    sectionId === 'portfolio' || sectionId === 'dealHome'
);

export const sortChildrenAlpha = (children: ISideNavSubItem[]): ISideNavSubItem[] => (
    [...children].sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }))
);
